import * as React from 'react';
import classnames from 'classnames';

import './layout-block.scss';

export interface LayoutBlockProps extends React.HTMLAttributes<HTMLDivElement> {
	scrollable?: boolean;
	inline?: boolean;
	fill?: boolean;
	align?: 'left' | 'center' | 'right';
	verticalAlign?: 'left' | 'center' | 'right';
}


export const LayoutBlock: React.FC<LayoutBlockProps> = props => {
	var lbClass = props.align ? 'lb-' + props.align : null;
	var lbVClass = props.verticalAlign ? 'lb-vertical-' + props.verticalAlign : null;
	var scrollable = props.scrollable;
	var divProps = { ...props };

	delete divProps.inline;
	delete divProps.fill;
	delete divProps.align;
	delete divProps.verticalAlign;
	delete divProps.scrollable;

	return (
		<div
			{...divProps}
			className={classnames(
				{
					'layout-block': !props.inline,
					'layout-inline-block': !!props.inline,
					'lb-fill': props.fill,
				},
				lbClass,
				lbVClass,
				props.className
			)}
		>
			{scrollable ? <div className='layout-scrollable full-absolute'>{props.children}</div> : props.children}
		</div>
	);
};

export default LayoutBlock;

